"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var E_ERROR;
(function (E_ERROR) {
    E_ERROR["CUSTOM"] = "errCustom";
    E_ERROR["NOT_IN_APP"] = "errInApp";
    E_ERROR["NOT_LOGIN"] = "errLogin";
    E_ERROR["NO_CONNECTION"] = "errConnection";
    E_ERROR["INVALID_RESPONSE"] = "errResponse";
})(E_ERROR = exports.E_ERROR || (exports.E_ERROR = {}));
var E_STATUS;
(function (E_STATUS) {
    E_STATUS[E_STATUS["FAIL"] = 0] = "FAIL";
    E_STATUS[E_STATUS["SUCCESS"] = 1] = "SUCCESS";
    E_STATUS[E_STATUS["CANCEL"] = 2] = "CANCEL";
})(E_STATUS = exports.E_STATUS || (exports.E_STATUS = {}));
var E_REDIRECT_TAB;
(function (E_REDIRECT_TAB) {
    E_REDIRECT_TAB[E_REDIRECT_TAB["SIGNUP"] = 0] = "SIGNUP";
    E_REDIRECT_TAB[E_REDIRECT_TAB["LOGIN"] = 1] = "LOGIN";
})(E_REDIRECT_TAB = exports.E_REDIRECT_TAB || (exports.E_REDIRECT_TAB = {}));
//# sourceMappingURL=dataTypes.js.map